export default {"icons":{"iconfont":"mdi"},"theme":{"themes":{"light":{"primary":"#B39C7D"}}}}
